import Api from '@/lib/api-wrapper';
import Knack from '@/lib/Knack';

const knack = new Knack();

knack.Api = Api;

export { knack };
